import React from 'react';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NSButton } from 'bricks';

export const BackOption = {
    label: 'BACK',
    value: 'back',
    disabled: false,
    submenu: undefined,
    toggle: false,
    component: (
        <div className="menu">
            <FontAwesomeIcon icon={faChevronLeft} className="mr-1" />
            BACK
        </div>
    ),
};

export const DealScenariosOption = {
    value: 'Deal Scenarios',
    label: 'DEAL SCENARIOS',
    disabled: true,
    component: <span className="text-primary">DEAL SCENARIOS</span>,
};

export const UncategorizedScenariosOption = {
    value: 'Uncategorized Scenarios',
    label: 'UNCATEGORIZED',
    disabled: true,
    component: <span className="text-primary">UNCATEGORIZED</span>,
};

export const createNewScenarioOption = (handleCreateScenario: () => void, dealName?: string) => ({
    value: 'new',
    label: '+ New scenario',
    disabled: false,
    component: (
        <div className="w-100 p-2 button-container">
            <NSButton
                color="primary"
                outline
                className="w-100 heap-deal-back-of-envelope-new-scenario"
                text={dealName ? `+ New scenario in ${dealName}` : '+ New scenario'}
                callback={handleCreateScenario}
            />
        </div>
    ),
});
